import React, { useEffect, useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import HeaderDashboard from '../Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { HttpService } from '../library';
import { toast } from 'react-toastify';
import exportFromJSON from 'export-from-json'
import { SystemDashboardLayout, SystemPanel } from 'library';
import SystemDatePicker from '../library/inputs/SystemDatePicker';
import moment from 'moment';
const DeductionReport = () => {

    const [dataLoader, setDataLoader] = useState(false);
    var cTotal = 0;
    var dTotal = 0;
    var total = false;
    const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), 0, 1));
    const [endDate, setEndDate] = useState(new Date());
    const [title, setTitle] = useState("Deduction/Contribution Summary Report");

    const [filterOne, setFilterOne] = useState(true);
    const [filterTwo, setFilterTwo] = useState(true);
    const [filterThree, setFilterThree] = useState(true);
    const [deductionCodes, setDeductionCodes] = useState({});
    const [contributionCodes, setContributionCodes] = useState({});
    const [locationCodes, setLocationCodes] = useState({});

    const [selectedDeductionCode, setSelectedDeductionCode] = useState([]);
    const [selectedContributionCode, setSelectedContributionCode] = useState([]);
    const [selectedLocationCodes, setSelectedLocationCodes] = useState([]);

    const [allDeductionCode, setAllDeductionCode] = useState(false);
    const [allContributionCode, setAllContributionCode] = useState(false);
    const [allLocationCode, setAllLocationCode] = useState(false);
    const [dataResults, setDataResults] = useState([]);
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {

        if (e.target.name.includes('deduction')) {
            if (e.target.checked) {
                const deduction = selectedDeductionCode.slice();
                deduction.push('[' + e.target.value + ']');
                setSelectedDeductionCode(deduction);
            } else {
                const deduction = selectedDeductionCode.filter((t) => t !== '[' + e.target.value + ']');
                setSelectedDeductionCode(deduction);
            }
        } else if (e.target.name.includes('contribution')) {
            if (e.target.checked) {
                const contribution = selectedContributionCode.slice();
                contribution.push('[' + e.target.value + ']');
                setSelectedContributionCode(contribution);
            } else {
                const contribution = selectedContributionCode.filter((t) => t !== '[' + e.target.value + ']');
                setSelectedContributionCode(contribution);
            }
        } else {
            if (e.target.checked) {
                const location = selectedLocationCodes.slice();
                location.push(e.target.value);
                setSelectedLocationCodes(location);
            } else {
                const location = selectedLocationCodes.filter((t) => t !== '[' + e.target.value + ']');
                setSelectedLocationCodes(location);
            }
        }
    }

    const formValidator = () => {
        var errorMsgs = [];
        if ((startDate == '' || startDate == null) || (endDate == '' || endDate == null)) {
            toast.error("Please select start and end date. Start date cannot be greater than end date. Also check Deduction/Contirbution code filter.");
            return false;
        }
        else if ((startDate > endDate)) {
            toast.error("Start date cannot be greater than end date.");
            return false;
        }
        return true;
    }

    const searchHandler = async () => {
        if (formValidator()) {
            setErrors([]);
            const Entity = new FormData();
            Entity.append('StartDate', moment(startDate).format("YYYY-MM-DD"));
            Entity.append('EndDate', moment(endDate).format("YYYY-MM-DD"));
            Entity.append('DeductionCodes', selectedDeductionCode.sort());
            Entity.append('ContributionCodes', selectedContributionCode.sort());
            Entity.append('LocationCodes', selectedLocationCodes.sort());
            setDataLoader(true);
            setDataResults([]);
            await HttpService.post("Report/DeductionContributionReport", Entity).then((response) => {
                setDataResults(response.data);
                setDataLoader(false);
                setTitle(`Deduction/Contribution Summary Report For: ${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`)
            }).catch(function (error) {
                setDataResults([]);
                setDataLoader(false);
            });
        }
    }

    const getDeductionCodeList = async () => {
        await HttpService.get("Report/DedcutionCodeList").then((response) => {
            setDeductionCodes(response.data.Data);
            allDeduction(true);
        }).catch((error) => {

        })
    }
    const getContributionCodeList = async () => {
        await HttpService.get("Report/ContributionCodeList").then((response) => {
            setContributionCodes(response.data.Data);
            allContribution(true);
        }).catch((error) => {

        })
    }
    const getLocationCodeList = async () => {
        await HttpService.get("Report/LocationCodeList").then((response) => {
            setLocationCodes(response.data.Data);
            allLocation(true);
        }).catch((error) => {

        })
    }
    useEffect(() => {
        getDeductionCodeList();
        getContributionCodeList();
        getLocationCodeList();

    }, [])

    /**
     * @author: Sandeep Sirohi
     * @description: Export report to excel.
     */
    const excelExport = () => {
        const table = document.getElementById('tblReport');
        // Use the xlsx library to convert the table to a workbook
        const wb = XLSX.utils.table_to_book(table, { sheet: "Sheet1", raw: true });
        // Write the workbook to a binary string and trigger the download
        XLSX.writeFile(wb, 'DeductionContribution Report.csv');

        //exportFromJSON({
        //    data: dataResults, fileName: 'Deduction/Contribution Report.csv', exportType: exportFromJSON.types.csv
        //});
    };

    const allDeduction = (value) => {
        setAllDeductionCode(value);
        var deductionlist = document.querySelectorAll('.deduction_check_boxes input[type=checkbox]')
        const deduction = [];
        if (value == true) {
            deductionlist.forEach(x => x.checked = true);
            for (let i = 0; i < deductionlist.length > 0; i++) {
                if (deductionlist[i].value != "on") {
                    deduction.push('[' + deductionlist[i].value + ']');
                    setSelectedDeductionCode(deduction);
                }
            }
        } else {
            setSelectedDeductionCode([]);
            deductionlist.forEach(x => x.checked = false);
        }
    }
    const allContribution = (value) => {
        setAllContributionCode(value);
        var contributionlist = document.querySelectorAll('.contribution_check_boxes input[type=checkbox]');
        const contribution = [];
        if (value == true) {
            contributionlist.forEach(x => x.checked = true);
            for (let i = 0; i < contributionlist.length > 0; i++) {
                if (contributionlist[i].value != "on") {
                    contribution.push('[' + contributionlist[i].value + ']');
                    setSelectedContributionCode(contribution);
                }
            }
        } else {
            setSelectedContributionCode([]);
            contributionlist.forEach(x => x.checked = false);
        }
    }

    const allLocation = (value) => {
        setAllLocationCode(value);
        var locationlist = document.querySelectorAll('.location_check_boxes input[type=checkbox]');
        const location = [];
        if (value == true) {
            locationlist.forEach(x => x.checked = true);
            for (let i = 0; i < locationlist.length > 0; i++) {
                if (locationlist[i].value != "on") {
                    location.push(locationlist[i].value);
                    setSelectedLocationCodes(location);
                }
            }
        } else {
            setSelectedLocationCodes([]);
            locationlist.forEach(x => x.checked = false);
        }
    }

    /**
     * @author:Sandeep Sirohi
     * @description: format currency for the report.
     */
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
    });

    return (<>
        <div className="DashboardWrapperChild">
            <div className="contentWrapper">
                <HeaderDashboard title={title} tagLine="" />
                <div className="container-fluid fieldsetGridAndForm  mt-80">
                    <SystemPanel
                        toolbar={[<button key={Math.random()} className="btn btn-default" onClick={excelExport}><span class="icon-download"></span> Download</button>]}
                        label="Report" showAdd={false} showRefresh={false} showArchive={false}>
                        <div className="row">

                            <div className="col-md-12 col-12">
                                <div className="searchControlWrapper">
                                    <div className="col-md-2 col-12">
                                        <SystemDatePicker labelClass="col-md-4" componentClass="col-md-8" value={startDate} label="Start date" onkeydown="return false;" onChange={(e) => {
                                            if (e) {
                                                setStartDate(e.target.value);
                                            }
                                        }} />
                                    </div>
                                    <div className="col-md-2 col-12">
                                        <SystemDatePicker labelClass="col-md-4" componentClass="col-md-8" value={endDate} label="End date" onChange={(e) => {
                                            if (e) {
                                                setEndDate(e.target.value);
                                            }
                                        }} />
                                    </div>
                                    <div className="col-md-1 col-12 buttonSubmit">
                                        <button onClick={(e) => { searchHandler() }} title="Generate report" className="btn btnSave">Search</button>
                                    </div>
                                </div>

                                <div className="searchControlWrapper flexCodes">

                                    <div className="searchControlBox searchControlBox50">
                                        <div className="formGroupContentWrapper" onClick={(e) => {
                                            setFilterOne(!filterOne);
                                        }}>
                                            <label><span style={{ background: 'orange', marginTop: '7px', width: '15px', height: '15px', display: 'inline-block' }}></span>&nbsp;&nbsp;Deduction Codes</label>
                                            <span className="spanIconBold">{/*<FaChevronDown />*/} <span class="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterOne == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer deduction_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allDeduction(true);

                                                        } else {
                                                            allDeduction(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    deductionCodes && deductionCodes.length > 0 ?
                                                        deductionCodes.map((code, index) => {
                                                            if (code.length > 0) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer deduction_check_boxes">
                                                                        <label className="normal-text"><input name={"deduction" + index} onChange={handleChange} type="checkbox" value={code} />
                                                                            &nbsp;{code}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className="searchControlBox searchControlBox50">
                                        <div className="formGroupContentWrapper" onClick={() => {
                                            setFilterTwo(!filterTwo);
                                        }}>
                                            <label> <span style={{ background: 'gray', marginTop: '7px', width: '15px', height: '15px', display: 'inline-block' }}></span>&nbsp;&nbsp;Contribution Codes</label>
                                            <span className="spanIconBold">{/*<FaChevronDown />*/} <span class="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterTwo == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer contribution_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allContribution(true);
                                                        } else {
                                                            allContribution(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    contributionCodes && contributionCodes.length > 0 ?
                                                        contributionCodes.map((code, index) => {
                                                            if (code.length > 0) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer contribution_check_boxes">
                                                                        <label className="normal-text"><input name={"contribution" + index} onChange={handleChange} type="checkbox" value={code} />
                                                                            &nbsp;{code}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }


                                            </div>
                                        </div>
                                    </div>

                                    <div className="searchControlBox searchControlBox50">
                                        <div className="formGroupContentWrapper" onClick={() => {
                                            setFilterThree(!filterThree);
                                        }}>
                                            <label>Location Codes</label>
                                            <span className="spanIconBold"><span class="icon-arrow_down"></span></span>
                                        </div>
                                        <div className="filterCheckBox clickCheckBox scrollChange" style={{ display: `${filterThree == true ? 'none' : 'block'}` }} >
                                            <div className="filtercheckboxWrapper">
                                                <div className="filtercheckboxContainer location_check_boxes">
                                                    <input type="checkbox" onClick={(e) => {
                                                        if (e.target.checked) {
                                                            allLocation(true);
                                                        } else {
                                                            allLocation(false);
                                                        }
                                                    }} />
                                                    <label className="normal-text">All</label>
                                                </div>
                                                {
                                                    locationCodes && locationCodes.length > 0 ?
                                                        locationCodes.map((code, index) => {
                                                            if (code.length > 0) {
                                                                return (
                                                                    <div key={index} className="filtercheckboxContainer location_check_boxes">
                                                                        <label className="normal-text"><input name={"location" + index} onChange={handleChange} type="checkbox" value={code} />
                                                                            &nbsp;{code}</label>
                                                                    </div>)
                                                            }
                                                        })
                                                        : null
                                                }


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 d-flex justify-content-center">
                                {dataLoader ? <div className="loaderApi">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" stroke="#000">
                                        <g fill="none" fill-rule="evenodd">
                                            <g transform="translate(1 1)" stroke-width="2">
                                                <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                                    <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                                                </path>
                                            </g>
                                        </g>
                                    </svg>
                                </div> : ''}
                                {
                                    Array.isArray(dataResults) && dataResults.length > 0 ?
                                        <div className="table-responsive tableResponsiveReport">
                                            <table id="tblReport" className="table">
                                                <thead>
                                                    <tr>
                                                        <th class="text-left" colSpan={Object.keys(dataResults && Array.isArray(dataResults) && dataResults[0]).length}>
                                                            {`Report for Check Date Between: ${moment(startDate).format("MM/DD/YYYY")} - ${moment(endDate).format("MM/DD/YYYY")}`}
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        {Object.keys(dataResults && Array.isArray(dataResults) && dataResults[0]).map((e, i) => {
                                                            return (
                                                                <th className={e.indexOf("Total") > 0 ? "total-col" : ""} key={i} style={{ background: (e.indexOf('D_') == 0 ? 'orange' : (e.indexOf('C_') == 0 ? 'gray' : '')), textAlign: i < 3 ? "left" : "right" }}>
                                                                    {e.slice(2)}
                                                                </th>
                                                            )
                                                        })}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {dataResults && Array.isArray(dataResults) && dataResults.map((val, index) => {
                                                        return (
                                                            <tr key={index}>{Object.entries(val).map((e, i, arr) => {
                                                                return (
                                                                    e[0] != "on" ?
                                                                        <td className={(e[0].indexOf("Total") > 0 ? "total-col" : "")} style={{ textAlign: i < 3 ? "left" : "right" }} key={i}>
                                                                            {
                                                                                i < 4 ? <b>{e[1]}</b> :
                                                                                    (e[1] > 0 ? formatter.format(e[1]) :
                                                                                        e[1] < 0 ? '(' + formatter.format(Math.abs(e[1])) + ')' : '')
                                                                            }
                                                                        </td> : ""
                                                                )
                                                            })}
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                        : "No data found !!"
                                }
                            </div>
                        </div>
                    </SystemPanel>
                </div>
            </div >
        </div >
    </>)
};

export default DeductionReport;